<template>
    <div class="per-avatar-area">
        <img
            class="per-avatar"
            :src="avatarUrl(user.id || user.uId, user.headId)"
            alt=""
            loading="lazy"
            :onerror="defaultAvatar"
        >
        <!--  <div-->
        <!--      v-show="showWord"-->
        <!--      class="per-avatar-div"-->
        <!--      :class="-->
        <!--          'avatarBg-' + initAvatarBgc(user.uId || user.user_id || user.id)-->
        <!--      "-->
        <!--  >-->
        <!--      {{ initAvatarName(user.name) }}-->
        <!--  </div>-->
    </div>
</template>

<script>
import defaultAvatar from '@/assets/images/contacts/longxiaohu.png'
import { configer } from '@/config'
export default {
    name: 'Avatar',
    props: {
        user: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            defaultAvatar: 'this.src="' + defaultAvatar + '"',
            showWord: false,
            contactsAvatarURL: configer.contactsAvatarURL
        }
    },
    computed: {
        isGroup() {
            return this.user.isGroup
        }
    },
    methods: {
        initAvatarName(name) {
            // 如果没有头像，中文下显示最后一个汉字，英文下显示第一个英文字母
            if (!name) {
                return name
            }
            const isChinese = /^[^\x20-\xff]+$/.test(name)
            return isChinese ? name.slice(-1) : name[0].toUpperCase()
        },
        initAvatarBgc(id) {
            const LENGTH = 6
            return id ? id.slice(-1).charCodeAt(0) % LENGTH : 0
        },
        avatarUrl(uid, headId) {
            if (uid && headId) {
                headId = +headId
                if (headId > 10) {
                    return (
                        this.contactsAvatarURL +
                        uid +
                        '.jpg?headId=' +
                        headId
                    )
                } else if (headId > 0 && headId <= 10) {
                    return (
                        this.contactsAvatarURL +
                        'default/' +
                        uid +
                        '.jpg?headId=' +
                        headId
                    )
                }
            } else if (
                (this.user.fullAvatarUrl && this.user.fullAvatarUrl !== '') ||
                (this.user.portraitUrl && this.user.portraitUrl !== '') ||
                (this.user.avatar && this.user.avatar !== '')
            ) {
                // 用户有完整头像地址，直接展示
                if (this.user.portraitUrl.indexOf('{1}') >= 0) {
                    this.user.portraitUrl = this.user.portraitUrl.replace(
                        '{1}',
                        '/small/'
                    )
                }
                return (
                    this.user.fullAvatarUrl ||
                    this.user.portraitUrl ||
                    this.user.avatar
                )
            } else {
                return defaultAvatar
            }
        }
    }
}
</script>

<style lang="scss" scoped>
/*头像*/
.per-avatar-area {
    width: 40px;
    height: 40px;
    position: relative;
    cursor: pointer;
    .per-avatar {
        width: 100%;
        height: 100%;
        background-color: #f5f5f5;
        border-radius: 50%;
        position: absolute;
        top: 0;
        left: 0;
    }
    .per-avatar-div {
        width: 100%;
        height: 100%;
        text-align: center;
        border-radius: 50%;
        color: #ffffff;
        font-size: 20px;
        background-color: #f07575;
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;
    }
    .avatarBg-0 {
        background-color: #75b6f0;
    }
    .avatarBg-1 {
        background-color: #eeae5b;
    }
    .avatarBg-2 {
        background-color: #60bbf2;
    }
    .avatarBg-3 {
        background-color: #f27c60;
    }
    .avatarBg-4 {
        background-color: #f16e6e;
    }
    .avatarBg-5 {
        background-color: #609af2;
    }
}
</style>
